import { render, staticRenderFns } from "./elcolitem.vue?vue&type=template&id=ba8cd692&"
import script from "./elcolitem.vue?vue&type=script&lang=js&"
export * from "./elcolitem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports